/* eslint-disable */

import jsonp from "@/libs/api.request.js";
import { ref, onMounted, createApp, nextTick, reactive } from "vue";
import Tabs from "@/class/Tabs";

export function useTabs(data: string) {
  console.log(data);

  data = data.replace(/[\r\n\t]/g, "");
  console.log(data);

  let json = {};
  let error = "";
  try {
    json = JSON.parse(data);
  } catch (error) {
    error = error;
  }

  let tabs: tabs = reactive({
    data: JSON.parse(data),
    error: error,
  });
  console.log(tabs);

  return { tabs, error };
}
